import script from "./ModalPayCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalPayCard.vue?vue&type=script&lang=ts&setup=true"

import "./ModalPayCard.vue?vue&type=style&index=0&id=1f5c7544&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f5c7544"]])

export default __exports__